<template>
  <div class="emap-thematic-list" v-if="hasData">
    <i-Collapse v-model="value1" ref="thematicDrag">
      <i-Panel v-for="(value, key) in list" :key="key" :name="value.title">
        <label>{{ value.title }}</label>
        <span class="drop" :class="isOpen(value.title) ? 'up' : 'down'"></span>
        <div slot="content">
          <i-Tree check-strictly check-directly :data="value.children" show-checkbox :render="treeRender"
            @on-check-change="onCheck"></i-Tree>
        </div>
      </i-Panel>
    </i-Collapse>
    <div class="plan-tip" :style="{ top: planY + 'px', left: planX + 'px' }" v-show="planDetail">
      <article>
        <header class="plan-tip-header">{{ detailTitle }}</header>
        <main class="plan-tip-content">
          <div>描述：</div>
          <p>{{ planDescription }}</p>
          <div style="font-weight: bold">时间：</div>
          <p>{{ planDate }}</p>
          <div style="font-weight: bold">数据来源：</div>
          <p>{{ planSource }}</p>
        </main>
      </article>
    </div>
    <!-- v-if="showMapTip" v-if="mapTipArr.length != 0" -->
    <div class="flow-tip" :style="{ top: y + 'px', left: x + 'px' }" v-if="showMapTip">
      <p class="myMapTip" v-for="(item, index) in mapTipArr" :key="index">
        <span>{{ item.title }}：</span>
        <span>{{ item.value }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import thematicChart from "./thematicChart.vue";
import thematicTable from "./thematicTable.vue";
import thematicTools from "./thematicTools.vue";

import { request } from "@/utils/http";
import { deepCopy } from "@/utils/misc";
import createService from "@/utils/serviceUtil/creators";

import eventmix, { eventMgr } from "./events";
import rendermix from "./components/treeRender.js";

import RCLayer from "./js/thematicRenderColorLayer.js";
import HMLayer from "./js/thematicHeatMapLayer.js";
import TwosLayer from "./js/thematicTwosMapLayer.js";
import RoadsLayer from "./js/thematicRoadsMapLayer.js";
import ClusterLayer from "./js/thematicClusterMapLayer.js";
import VtsLayer from "./js/thematicVtsLayer";
import VectorLayer from './js/thematicVectorMapLayer.js';

import { mapState, mapMutations, mapGetters } from "vuex";
import { MiscUtil } from "../../../utils/miscUtil";
import Popup from './components/popups/FeaturePickPopup';
// import Popup from './components/popups/Popup';

export default {
  mixins: [eventmix, rendermix],
  unWatch() {
    return {
      echartslayer: null,
      series: [],
      currentRow: null,
    };
  },
  inject: ["MapView"],
  data() {
    return {
      value1: [],
      plans: [],
      spinShowList: true,
      spinShow: false,
      list: [],
      data1: [],
      x: 0,
      y: 0,
      title: "",
      text: "",
      showMapTip: false,
      // mapTipTitle: '',
      // mapTipValue: null,
      // mapTipName: null,
      mapTips: [],
      hoverIds: [],
      showChartTip: false,
      planDetail: false,
      detailTitle: "",
      planY: 0,
      planX: 0,
      planDescription: "",
      planDate: "",
      planSource: "",
      queryRenderLayers: [],
      hasData: false,
      vtsQueryFieldsConfig: [],
      wfsQueryFieldsConfig: [],
      allFeatures: [],
      vwmtsRow: null,
      vwmtsId: "",
    };
  },
  computed: {
    showTitle() {
      return this.title !== "";
    },
    isOpen() {
      return function (value) {
        let isIn = this.value1.filter((v) => v == value);
        let flag = isIn.length > 0 ? true : false;
        return flag;
      };
    },
    ...mapState("thematic", {
      timeLineShow: "timeLineShow",
      timesData: "timesData",
    }),
  },
  created() {
    const _this = this;
    //请求列表数据
    const promise = new Promise((resolve, reject) => {
      const params = {
        type: "thematic",
      };
      request("admin/mapFront/queryMapThematicTreeList", { data: params })
        .then((json) => {
          const jsonTree = json.map((j) => {
            return {
              id: Number(j.id),
              parentId: Number(j.parentId),
              name: String(j.name),
              istree: true,
            };
          });
          resolve(jsonTree);
        })
        .catch(reject);
    });
    promise.then((jsonTree) => {
      if (jsonTree.length === 0) {
        this.$Message.warning("专题地图未配置数据！");
        this.onClose();
      }
      this.hasData = true;
      request("admin/mapFront/queryMapThematicPlanList", {
        data: { type: "2D" },
      }).then((json) => {
        const jsonPlan = [];
        for (let i = 0; i < json.length; i++) {
          //  if (json[i].type === '2D') {
          jsonPlan.push({
            planid: Number(json[i].id),
            parentId: Number(json[i].treeid),
            name: String(json[i].name),
            istree: false,
          });
          //   } else continue;
        }
        for (let i = 0; i < jsonTree.length; i++) {
          for (let j = 0; j < json.length; j++) {
            if (Number(json[j].treeid) === Number(jsonTree[i].id)) {
              this.plans.push({
                id: Number(json[j].id),
              });
            }
          }
        }
        const jsonAll = [...jsonPlan, ...jsonTree];
        const listAll = _this.createTree(jsonAll, 2);
        _this.list = listAll;
        _this.$nextTick().then(() => {
          let nameArr = [];
          _this.list.map((l) => {
            nameArr.push(l.title);
          });
          // _this.value1 = _this.list[0].title;
          // _this.value1 = nameArr
          _this.spinShowList = false;
        });
      });
    });
  },
  mounted() {
    EVENTHUB.on("clearThematic", this.onClose);
    EVENTHUB.on("changeVWMTSTime", this.changeVWMTSTime);
  },
  beforeDestroy() {
    this.echartslayer.remove();
    EVENTHUB.off("clearThematic", this.onClose);
  },
  methods: {
    /***
     * 方案勾选响应事件
     ***/
    onCheck(datas, data) {
      this.currentRow = data;
      if (data.checked) {
        // this.$set(data, "checked", false);
        if (data.layerIds) {
          //重复勾选，避免再次请求
          this.setCreatedPlanDisplay(data, true);
        } else {
          this.showPlan(data);
        }
      } else {
        //取消勾选
        this.setCreatedPlanDisplay(data, false);
        this.$set(data, "checked", false);
      }
    },
    /***
     * 菜单框关闭事件
     ***/
    onClose() {
      // this.$destroy();
      //清空所有专题图层
      this.MapView.clearGroup("custom");
      for (let val of this.queryRenderLayers) {
        if (this.MapView.map.getLayer(val)) {
          this.MapView.map.removeLayer(val);
          this.MapView.map.removeSource(val);
        }
      }
      if (this.vtsQueryFieldsConfig.length > 0) {
        this.vtsQueryFieldsConfig.map((item) => {
          this.MapView.map.removeSource(item.id);
        });
      }

      this.$_setTimeLineShow(false);
      this.$_setTimesData(null);
      this.clearChecked(this.list);
    },
    clearChecked(arr) {
      arr.forEach((item) => {
        if (item.checked) {
          item.checked = false;
          eventMgr.fire("removeTablePlan", item.planId);
          eventMgr.fire("removeChartPlan", item.planId);
          eventMgr.fire("removeTablePlan", item.planId);
        }
        if (item.layerIds && item.layerIds.length > 0) {
          item.layerIds = null;
        }
        if (item.children && item.children.length > 0) {
          this.clearChecked(item.children);
        }
      });
      return arr;
    },
    /*******************界面响应事件-end************************/

    /***
     * 已构造的方案图层显隐控制
     ***/
    async setCreatedPlanDisplay(row, display) {
      const _this = this;
      let vwmtsFlag =
        this.vwmtsRow && this.vwmtsRow.title == row.title ? true : false;
      //显示
      if (display) {
        if (row.layerIds.length > 0) {
          row.layerIds.forEach((l) => {
            this.MapView.map.setLayoutProperty(l, "visibility", "visible");
          });
        }
        if (vwmtsFlag) {
          this.$_setTimeLineShow(true);
          this.$_setTimesData(this.timesData);
        }
        if (row.model === "Charts") {
          this.$CompManager.checkAdd(thematicTable);
          this.$CompManager.checkAdd(thematicChart);
          const planInfo = await this.getPlanInfo(row.planId);
          planInfo.planId = row.planId;
          planInfo.title = row.title;
          eventMgr.fire("addTablePlan", planInfo);
          eventMgr.fire("addChartPlan", planInfo);
        }
        if (row.model === "Clusters") {
          this.$CompManager.checkAdd(thematicTable);
          const planInfo = await this.getPlanInfo(row.planId);
          planInfo.planId = row.planId;
          planInfo.title = row.title;
          eventMgr.fire("addTablePlan", planInfo);
          let currentTableData = this.allFeatures.filter(
            (item) => item.id == planInfo.planId
          );
          if (currentTableData.length > 0) {
            eventMgr.fire(
              "getAllClusterData",
              currentTableData[0].data,
              planInfo.planId
            );
          }
        }
        if (row.model === "Twos" || row.model === "Roads") {
          const _series = deepCopy(this.echartslayer.chart.getOption().series);
          const newSeries = _series.map((item, index) => {
            if (row.planId === item.planid) {
              return _this.series[index];
            } else {
              return item;
            }
          });
          this.echartslayer.chart.setOption({
            series: newSeries,
          });
        }
        this.$set(row, "checked", true);
      }
      //隐藏
      if (!display) {
        if (vwmtsFlag) {
          this.$_setTimeLineShow(false);
          this.$_setTimesData(this.timesData);
        }

        if (row.model === "Charts" || row.model === "Clusters") {
          eventMgr.fire("removeTablePlan", row.planId);
          eventMgr.fire("removeChartPlan", row.planId);
        }
        if (row.model === "Clusters") {
          eventMgr.fire("removeTablePlan", row.planId);
        }
        if (row.layerIds && row.layerIds.length > 0) {
          row.layerIds.forEach((l) => {
            if(this.MapView.map.getLayer(l)) {
              this.MapView.map.setLayoutProperty(l, "visibility", "none");
            }
          });
        }
        if (row.model === "Twos" || row.model === "Roads") {
          const _series = deepCopy(this.echartslayer.chart.getOption().series);
          const newSeries = _series.map((s) => {
            if (row.planId === s.planid) {
              return { planid: s.planid, data: [] };
            } else {
              return s;
            }
          });
          this.echartslayer.chart.setOption({
            series: newSeries,
          });
        }
      }
    },
    /***
     *构造方案
     ***/
    async showPlan(data) {
      this.spinShow = true;
      //获取方案配置信息
      const planInfo = await this.getPlanInfo(data.planId);
      const basicMapInfo = planInfo.configcont.maps;
      //方案配置中的基础图层
      const basicLayers = await this.createBasicLayers(basicMapInfo);
      console.log(basicLayers, "basicLayers");

      let isVWMTS = this.judgeVWMTS(basicMapInfo);
      this.MapView.addLayers2Group(basicLayers, "custom");
      data.layerIds = [];

      let maxExtent = ""
      basicLayers.forEach((l) => {
        // vts 图层
        if (l.data.layer.layerData) {
          l.data.layer.layerData.forEach((ll) => data.layerIds.push(ll.id));
          maxExtent = l.data.layer.layerData[0].metadata.maxExtent
        } else {
          data.layerIds.push(l.data.layer.id);
          maxExtent = l.data.layer.metadata.maxExtent
        }
        if (l.type == "VWMTS") {
          this.vwmtsId = l.data.layer.id;
        }
      });

      if (isVWMTS) {
        this.vwmtsRow = data;
      }
      if (maxExtent) {
        this.fitBoundsBaseLayer(maxExtent)
      }

      this.createThematicLayers(planInfo, data);
    },
    fitBoundsBaseLayer(maxExtent) {
      let lnglatArr = maxExtent.split(",")
      if (lnglatArr[0] < 100) {
        lnglatArr = lnglatArr.reverse()
      }
      lnglatArr.map((l, i) => {
        lnglatArr[i] = parseFloat(l)
      })
      const feature = {
        "type": "Feature",
        "properties": {},
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [[lnglatArr[0], lnglatArr[1]], [lnglatArr[0], lnglatArr[3]], [lnglatArr[2], lnglatArr[3]], [lnglatArr[2], lnglatArr[1]], [lnglatArr[0], lnglatArr[1]]]
          ]
        }
      }
      const features = [feature];
      const len = features.length;
      const geometries = new Array(len);
      for (let i = 0; i < len; ++i) {
        geometries[i] = GeoGlobe.Feature.fromGeoJson(
          features[i]
        )[0].geometry;
      }
      const geom = new GeoGlobe.Geometry.Collection(geometries);
      geom.calculateBounds();
      this.MapView.map.fitBounds(geom.bounds);
    },
    ...mapMutations("thematic", {
      $_setTimeLineShow: "setTimeLineShow",
      $_setTimesData: "setTimesData",
    }),
    judgeVWMTS(data) {
      let filter = data.filter((v) => v.serviceTypeStr == "VWMTS");
      if (filter.length > 0) {
        // 存在多时相方案
        this.$_setTimeLineShow(true);
        this.$_setTimesData(filter[0]);
      }

      return filter.length > 0 ? true : false;
    },
    async changeVWMTSTime(index) {
      let timesData = JSON.parse(JSON.stringify(this.timesData));
      timesData.info.time = timesData.info.times[index];
      this.$_setTimesData(timesData);

      const vwmtsLayers = await this.createBasicLayers([timesData]);
      this.MapView.map.removeLayer(this.vwmtsId);
      // let ids = this.vwmtsRow.layerIds
      // ids.map(id => {
      //   this.MapView.map.removeLayer(id)
      // })
      this.MapView.addLayers2Group(vwmtsLayers, "custom");
      let ids = this.vwmtsRow.layerIds;
      let findIndex = ids.findIndex((id) => id == this.vwmtsId);
      this.vwmtsRow.layerIds.splice(findIndex, 1);

      this.vwmtsRow.layerIds.push(vwmtsLayers[0].data.layer.id);
      this.vwmtsId = vwmtsLayers[0].data.layer.id;
    },
    async createVWMTSLayers(info) {
      return Promise.all(
        info.map((l) => {
          // 配置信息
          const info = l.info;
          const [minZoom, maxZoom] = info.zoomRange;
          // 创建图层
          return createService(info.type, info, minZoom, maxZoom).catch(
            (err) => {
              // 单独捕捉错误（避免穿件失败整个promise异常）
              // eslint-disable-next-line no-console
              console.error("创建图层失败：", info.name, err);
              return false;
            }
          );
        })
      );
    },
    /***
     *获取方案配置信息
     ***/
    async getPlanInfo(id) {
      return request("admin/mapFront/getMapThematicPlanDetail", {
        data: id,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((json) => {
        return json;
      });
    },
    /***
     *创建方案配置的基础图层
     ***/
    async createBasicLayers(info) {
      return Promise.all(
        info.map((l) => {
          // 配置信息
          const info = l.info;
          const [minZoom, maxZoom] = info.zoomRange;
          // 创建图层
          return createService(info.type, info, minZoom, maxZoom).catch(
            (err) => {
              // 单独捕捉错误（避免穿件失败整个promise异常）
              // eslint-disable-next-line no-console
              console.error("创建图层失败：", info.name, err);
              return false;
            }
          );
        })
      );
    },
    /***
     *创建方案配置中的专题图层
     ***/
    createThematicLayers(planInfo, data) {
      const _model = planInfo.configcont.basic.model;
      switch (_model) {
        case "Charts": //图表专题
          return this.creatChartsLayers(planInfo, data);
        case "Heats": //热力图专题
          return this.creatHeatsLayers(planInfo, data);
        case "Twos": //迁徙图专题
          return this.creatTwosLayers(planInfo, data);
        case "Roads": //轨迹图专题
          return this.creatRoadsLayers(planInfo, data);
        case "Clusters": //点聚合专题
          return this.creatClustersLayers(planInfo, data);
        case "BasicVector": //基础矢量
          // this.spinShow = false;
          // this.$set(data, 'checked', true);
          this.creatBasicVectorLayersNew(planInfo, data);
          return;
        default:
          this.$Message.error(`暂不支持的专题类型`);
          this.spinShow = false;
          break;
      }
    },
    /**基础矢量专题
     */
    creatBasicVectorLayers(planInfo, data) {
      var _this = this;
      data.model = "BasicVector";
      // WFS-点
      if (planInfo.configcont.thematic.serviceType === "WFS") {
        var serviceUrl = planInfo.configcont.thematic.serviceUrl;
        // serviceUrl= MiscUtil.getProxyUrl(serviceUrl)
        var serviceLayerName = planInfo.configcont.thematic.serviceLayer;
        var wfsQueryObj = new GeoGlobe.Query.WFSQuery(
          serviceUrl,
          serviceLayerName,
          {
            geometryName: "GEOMETRY",
            version: "1.0.0",
            maxFeatures: 999999,
          }
        );
        var Features = [];
        wfsQueryObj.query(null, function (features) {
          Features.push(features);
          let geojson = {
            type: "geojson",
            data: features.geojson,
          };
          let imgurl = planInfo.configcont.thematic.wfsConfig.imgUrl;
          MiscUtil.fetch(imgurl)
            .then((json) => {
              return json.imageData;
            })
            .then((imgData) => {
              // 加载图片
              _this.MapView.map.loadImage(imgData, function (error, image) {
                _this.MapView.map.addImage("img" + serviceLayerName, image);
                // 添加点数据源
                _this.MapView.map.addSource(
                  "vts_wfs_" + serviceLayerName,
                  geojson
                );
                var wfsLayerOptions = {
                  id: "vts_wfs_" + serviceLayerName, // 图层ID
                  type: "symbol", // 图层类型
                  source: "vts_wfs_" + serviceLayerName, // 数据源
                  layout: {
                    "icon-image": "img" + serviceLayerName, // 图片id
                    "icon-size": 1, // 图片大小
                  },
                };
                // 添加点图层
                _this.MapView.map.addLayer(wfsLayerOptions);
                data.layerIds.push(wfsLayerOptions.id);
                _this.queryRenderLayers.push(wfsLayerOptions.id);
                _this.enableLayerClick.push({
                  layerId: wfsLayerOptions.id,
                  enableClick: planInfo.configcont.thematic.wfsConfig.isClick,
                });
                _this.wfsQueryFieldsConfig.push({
                  id: wfsLayerOptions.id,
                  config: planInfo.configcont.thematic.wfsConfig.displayFields,
                });
                _this.spinShow = false;
                _this.$set(data, "checked", true);
              });
            });
        });
      } else {
        // VTS
        let Parameter = VtsLayer.checkParameter(planInfo);
        if (Parameter) {
          let { url, layerName, styleName } = Parameter;
          VtsLayer.initLayer(url, layerName, styleName).then((layer) => {
            this.MapView.map.addLayer(layer);
            console.log(layer, "vtslayer");
            this.MapView.map.fitBounds(layer.layers[0].metadata.bbox);
            // 获取图层id
            for (let val of layer.layers) {
              data.layerIds.push(val.id);
              this.queryRenderLayers.push(val.id);
            }
            this.vtsQueryFieldsConfig.push({
              id: layer.source_id,
              config: planInfo.configcont.thematic.vtsConfig.displayTable,
            });
            this.spinShow = false;
            this.$set(data, "checked", true);
          });
        }
      }
    },
    creatBasicVectorLayersNew(planInfo, data) {
      data.model = 'BasicVector';
      VectorLayer.initLayer(this, planInfo)
        .then(layer => {
          if (layer) {
            layer.bindAll({
              click: features => {
                if (features.length) {
                  // const displayFields = planInfo.configcont.thematic.wfsConfig.displayFields || [];
                  const displayFields = layer._options.displayFields || [];
                  this.MapView.fitBounds(features);
                  this.MapView.openPopup(
                      Popup,
                      {
                          feature: features[0],
                          fields: displayFields,
                          offset: [0, -25],
                      }
                  );
                } else {
                  this.MapView.closePopup(
                      Popup
                  );
                }
              },
            });
            this.$set(data, 'checked', true);
            this.MapView.map.fitBounds(layer.Bounds);
            layer.id.map(i => {
              data.layerIds.push(i);
              this.queryRenderLayers.push(i);
            });
            const planIndex = this.plans.findIndex(
              value => data.planId === value.id
            );
            this.plans[planIndex].layers = data.layerIds;
            this.setLayerIndex(planIndex);
          } else {
            this.$Message.error('方案参数配置错误！');
          }
          this.spinShow = false;
        })
        .catch(() => {
          this.spinShow = false;
        });
    },
    /***
     *图表专题
     ***/
    creatChartsLayers(planInfo, data) {
      data.model = "Charts";
      this.$set(data, "checked", true);
      const Parameter = RCLayer.checkParameter(planInfo);
      if (Parameter) {
        const {
          colors,
          ranges,
          url,
          // layerName,
          // zoomRange,
          field,
          showMap,
          mapMatchField,
        } = Parameter;
        if (data.plan) {
          data.plan.colors = colors;
          data.plan.ranges = ranges;
          data.plan.showMap = showMap;
        }
        planInfo.planId = data.planId;
        planInfo.title = data.title;
        this.$CompManager.checkAdd(thematicChart);
        eventMgr.fire("switchChartDisplay", true);
        this.$CompManager.checkAdd(thematicTable);
        eventMgr.fire("addTablePlan", planInfo);
        eventMgr.fire("addChartPlan", planInfo);
        // this.$CompManager.checkAdd(thematicTools);
        const showFileds = [];
        if (showMap && url !== "") {
          RCLayer.initLayer(this, planInfo)
            .then((res) => {
              if (res.info) {
                this.mapTips.push({
                  id: res.data[0].sourceId,
                  title: mapMatchField,
                  value: field,
                  showFileds: showFileds,
                });
                this.mapTips.push({
                  id: res.data[1].sourceId,
                  title: mapMatchField,
                  value: field,
                  showFileds: showFileds,
                });
                const { fillStops } = res.param;
                // this.mapTipTitle = mapMatchField
                // this.mapTipValue = field
                if (fillStops.length > 0) {
                  //构造 wfs-分段设色 图层
                  const wfsLayer = res.data[0];
                  const wfsLayerHover = res.data[1];
                  this.hoverIds = wfsLayerHover.id;
                  this.MapView.map.fitBounds(wfsLayer.Bounds);
                  eventMgr.on("updateData1", this.mapHoverChange);
                  //注册layer_id数组
                  // data.layerIds = []
                  wfsLayer.id.map((i) => {
                    data.layerIds.push(i);
                    this.queryRenderLayers.push(i);
                  });
                  const planIndex = this.plans.findIndex(
                    (value) => data.planId === value.id
                  );
                  this.plans[planIndex].layers = data.layerIds;
                  this.setLayerIndex(planIndex);
                }
                this.spinShow = false;
                this.$set(data, "checked", true);
              } else {
                this.spinShow = false;
                this.$Message.error("方案参数配置错误！");
              }
            })
            .catch(() => {
              this.spinShow = false;
            });
        } else {
          this.spinShow = false;
          this.$set(data, "checked", true);
        }
      } else {
        this.spinShow = false;
        this.$Message.error("方案参数配置错误！");
      }
    },
    /***
     *热力图专题
     ***/
    creatHeatsLayers(planInfo, data) {
      data.model = "heats";
      const Parameter = HMLayer.checkParameter(planInfo);
      if (Parameter) {
        const { url, layerName, zoomRange, colors, radius } = Parameter;
        const weightField = planInfo.configcont.thematic.weightField;
        const showField = planInfo.configcont.thematic.showField;
        const valueField = planInfo.configcont.thematic.valueField;
        const showFileds = planInfo.configcont.thematic.displayFields;
        HMLayer.initLayer(
          this,
          url,
          layerName,
          zoomRange,
          colors,
          radius,
          weightField
        )
          .then((wfsLayer) => {
            this.mapTips.push({
              id: wfsLayer.sourceId,
              title: showField,
              value: valueField,
              showFileds: showFileds,
            });
            // this.mapTipTitle = showField
            // this.mapTipValue = valueField
            this.MapView.map.fitBounds(wfsLayer.Bounds);
            this.spinShow = false;
            wfsLayer.id.map((i) => {
              data.layerIds.push(i);
              this.queryRenderLayers.push(i);
            });
            const planIndex = this.plans.findIndex(
              (value) => data.planId === value.id
            );
            this.plans[planIndex].layers = data.layerIds;
            this.setLayerIndex(planIndex);
          })
          .catch(() => {
            this.spinShow = false;
          });
        this.$set(data, "checked", true);
      } else {
        this.$Message.error("方案参数配置错误！");
      }
    },
    /***
     *迁徙图专题
     ***/
    async creatTwosLayers(planInfo, data) {
      const _this = this;
      data.model = "Twos";
      TwosLayer.initLayer(this, planInfo, data.planId)
        .then((res) => {
          if (res.info) {
            const _series = res.data;
            const series = deepCopy(this.echartslayer.chart.getOption().series);
            _series.forEach((s) => {
              series.push(s);
              _this.series.push(s);
            });
            _this.echartslayer.chart.setOption({
              series: series,
            });
            this.$set(data, "checked", true);
            this.spinShow = false;
          } else {
            this.spinShow = false;
            this.$Message.error("方案参数配置错误！");
          }
        })
        .catch(() => {
          this.spinShow = false;
        });
    },
    /***
     *轨迹图专题
     ***/
    creatRoadsLayers(planInfo, data) {
      const _this = this;
      data.model = "Roads";
      RoadsLayer.initLayer(this, planInfo, data.planId)
        .then((res) => {
          if (res.info) {
            const _series = res.data;
            const series = deepCopy(this.echartslayer.chart.getOption().series);
            series.push(_series);
            _this.series.push(_series);
            _this.echartslayer.chart.setOption({
              series: series,
            });
            this.$set(data, "checked", true);
            this.spinShow = false;
          } else {
            this.spinShow = false;
            this.$Message.error("方案参数配置错误！");
          }
        })
        .catch(() => {
          this.spinShow = false;
        });
    },
    /***
     *点聚合专题
     ***/
    creatClustersLayers(planInfo, data) {
      data.model = "Clusters";
      const Parameter = ClusterLayer.checkParameter(planInfo);
      if (Parameter) {
        //打开统计表
        planInfo.planId = data.planId;
        planInfo.title = data.title;
        this.$CompManager.checkAdd(thematicTable);
        eventMgr.fire("switchChartDisplay", false);
        eventMgr.fire("addTablePlan", planInfo);
        const { url, layerName, zoomRange } = Parameter;
        const showField = planInfo.configcont.thematic.showField;
        const valueField = planInfo.configcont.thematic.valueField;
        const showFileds = planInfo.configcont.thematic.displayFields;
        let imgUrl = "";
        if (planInfo.configcont.thematic.imgUrl) {
          imgUrl = planInfo.configcont.thematic.imgUrl;
        }
        ClusterLayer.initLayer(
          this,
          planInfo.planId,
          url,
          layerName,
          zoomRange,
          imgUrl
        )
          .then((wfsLayer) => {
            //自动填充前10条记录
            // eventMgr.fire("updateClusterData", wfsLayer.Features.slice(0, 9));
            eventMgr.fire("updateClusterData", wfsLayer.Features);
            eventMgr.fire(
              "getAllClusterData",
              wfsLayer.Features,
              planInfo.planId
            );
            this.allFeatures.push({
              id: planInfo.planId,
              data: wfsLayer.Features,
            });
            this.mapTips.push({
              id: wfsLayer.sourceId,
              title: showField,
              value: valueField,
              showFileds: showFileds,
            });
            // this.mapTipTitle = showField
            // this.mapTipValue = valueField
            this.MapView.map.fitBounds(wfsLayer.Bounds);
            this.spinShow = false;
            wfsLayer.id.map((i) => {
              data.layerIds.push(i);
              this.queryRenderLayers.push(i);
            });
            const planIndex = this.plans.findIndex(
              (value) => data.planId === value.id
            );
            this.plans[planIndex].layers = data.layerIds;
            this.setLayerIndex(planIndex);
          })
          .catch(() => {
            this.spinShow = false;
          });
        this.$set(data, "checked", true);
      } else {
        this.$Message.error("方案参数配置错误！");
      }
    },
    /***
     * 调整图层顺序
     ***/
    setLayerIndex(planIndex) {
      let blayers = [];
      for (let i = planIndex - 1; i > -1; i--) {
        if (this.plans[i].layers && this.plans[i].layers.length > 0) {
          blayers = this.plans[i].layers;
          break;
        }
      }
      const layerIds = this.plans[planIndex].layers;
      if (blayers.length > 0) {
        const bId = blayers[0];
        if (layerIds.length > 0) {
          for (let i = 0; i < layerIds.length; i++) {
            this.MapView.map.moveLayer(layerIds[i], bId);
          }
        }
      }
    },
  },
};
</script>
<style lang="less">
.ivu-collapse-header {
  background: #fff !important;
  height: 40px;
  color: #000 !important;
  line-height: 40px;
  font-size: 14px;

  i {
    display: none !important;
  }
}

.ivu-collapse {
  border-style: none;
  background: #fff !important;
}

.ivu-collapse-item:first-child {
  border-top: 1px solid #dcdee2 !important;
}

.ivu-collapse-item {
  /* border-top: 1px solid #dcdee2; */
  margin-bottom: 6px;
  border: 1px solid #dcdee2;
}

.ivu-collapse-header:hover {
  background: #eaf1fb !important;
}

.ivu-collapse-item-active {
  .ivu-collapse-header {
    background: #eaf1fb !important;
    color: #4187e7 !important;
  }
}

.myMapTip {
  padding: 3px;
  margin: 3px;
}

span.drop {
  position: absolute;
  right: 5px;
  top: 12px;
  width: 16px;
  height: 9px;
  background: url("./../../../assets/default/img/down-triangle.png") no-repeat center;
  transform: rotate(180deg) !important;
}

span.up {
  transform: rotate(0) !important;
}
</style>
